module.exports = __webpack_public_path__ + "img/image_gallery8.5dbf418d.jpg";